var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWinEmpty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 22,
    viewBox: "0 0 25 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.95663 4.12861C0.0144565 6.0937 0.0144565 9.27494 1.95663 11.24L6.83028 16.1712C8.77889 18.1428 11.9431 18.1428 13.8917 16.1712L17.406 12.6155L9.0181 4.12861C7.06949 2.157 3.90524 2.157 1.95663 4.12861ZM7.59562 5.5345L14.5935 12.6154L12.4693 14.7653C11.3036 15.9448 9.41847 15.9448 8.25276 14.7653L3.37911 9.83414C2.20696 8.64816 2.20696 6.72049 3.37911 5.5345C4.54483 4.35504 6.42991 4.35504 7.59562 5.5345Z",
    fill: "#9499A1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0443 4.12861C24.9865 6.0937 24.9865 9.27494 23.0443 11.24L18.1707 16.1712C16.2221 18.1428 13.0578 18.1428 11.1092 16.1712L7.59499 12.6155L15.9829 4.12861C17.9315 2.157 21.0957 2.157 23.0443 4.12861ZM17.4054 5.5345L10.4075 12.6154L12.5317 14.7653C13.6974 15.9448 15.5825 15.9448 16.7482 14.7653L21.6219 9.83414C22.794 8.64816 22.794 6.72049 21.6219 5.5345C20.4561 4.35504 18.5711 4.35504 17.4054 5.5345Z",
    fill: "#9499A1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.5 0H18.5C19.6046 0 20.5 0.89543 20.5 2V10.5C20.5 14.9183 16.9183 18.5 12.5 18.5C8.08172 18.5 4.5 14.9183 4.5 10.5V2C4.5 0.89543 5.39543 0 6.5 0Z",
    fill: "#B2B7BE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 12.5C14.433 12.5 16 10.933 16 9C16 7.067 14.433 5.5 12.5 5.5C10.567 5.5 9 7.067 9 9C9 10.933 10.567 12.5 12.5 12.5Z",
    fill: "#ECF0F4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 20H8.5C7.94772 20 7.5 20.4477 7.5 21C7.5 21.5523 7.94772 22 8.5 22H16.5C17.0523 22 17.5 21.5523 17.5 21C17.5 20.4477 17.0523 20 16.5 20Z",
    fill: "#9499A1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWinEmpty);
export default __webpack_public_path__ + "static/media/win_empty.cc0c527e871ffbd2f7685494e409f162.svg";
export { ForwardRef as ReactComponent };